class ProductTabBar extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('.titles');
      this.buildTabs();
      this.handleScrollSpy();
    }
  
    buildTabs() {
      const headings = document.querySelectorAll('#product-description .page-heading');
      if (!headings.length) return;
  
      headings.forEach((heading, i) => {
        const title = heading.textContent.trim();
        const id = title.toLowerCase().replace(/\s+/g, '-');
        heading.id = id;
  
        const span = document.createElement('span');
        span.textContent = title;
        span.dataset.target = id;
        span.className =
          'scrollTo cursor-pointer bg-transparent active:bg-transparent focus:bg-transparent hover:bg-transparent border-b-4 border-gray-400 pb-3 transition-all hover:text-black hover:border-black';
        if (i === 0) span.classList.add('active', 'text-black', 'border-red-600');
  
        span.addEventListener('click', () => {
          this.scrollToSection(id);
          this.activateTab(span);
        });
  
        this.container.appendChild(span);
      });
    }
  
    scrollToSection(id) {
      const el = document.getElementById(id);
      if (!el) return;
      window.scrollTo({ top: el.offsetTop - 140, behavior: 'smooth' });
    }
  
    activateTab(activeSpan) {
      this.querySelectorAll('.scrollTo').forEach(tab =>
        tab.classList.remove('active', 'text-black', 'border-red-600')
      );
      activeSpan.classList.add('active', 'text-black', 'border-red-600');
    }
  
    handleScrollSpy() {
      const headings = document.querySelectorAll('.vertical-description .page-heading');
      if (!headings.length) return;
  
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const id = entry.target.id;
              this.querySelectorAll('.scrollTo').forEach(tab => {
                const isActive = tab.dataset.target === id;
                tab.classList.toggle('active', isActive);
                tab.classList.toggle('text-black', isActive);
                tab.classList.toggle('border-red-600', isActive);
              });
            }
          });
        },
        { rootMargin: '-45% 0px -45% 0px' }
      );
  
      headings.forEach(h => observer.observe(h));
    }
  }
  
 
  customElements.define('product-tab-bar', ProductTabBar);

  /* ------------------ MOBILE ACCORDION BUILDER ------------------ */
  document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector("#mobile-accordion-container");
    const sections = document.querySelectorAll("#product-description .vertical-description .toggle-title");
    if (!container || !sections.length) return;
  
    function buildAccordion() {
      container.innerHTML = ""; // clear old accordions
      sections.forEach(section => {
        const heading = section.querySelector(".page-heading");
        const content = section.querySelector("div:not(.page-heading):not(.custom-line)");
        if (!heading || !content || !content.innerHTML.trim()) return; // skip empty ones
  
        const title = heading.textContent.trim();
        const details = document.createElement("details");
        details.className = "border-b border-gray-200 group";
        details.innerHTML = `
          <summary class="flex justify-between items-center cursor-pointer font-rajdhani font-black uppercase text-[20px] text-[#0B0C0D]">
            ${title}
            <svg class="w-5 h-5 transition-transform group-open:rotate-180" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </summary>
          <div class="mt-3 text-[#45474D] font-times text-[14px] leading-[24px] prose max-w-none">
            ${content.innerHTML}
          </div>
        `;
        container.appendChild(details);
      });
  
      initFaqButtons(); // reinit FAQ toggle for copied content
    }
  
    function initFaqButtons() {
      const faqBtns = document.querySelectorAll("#mobile-accordion-container .faq-btn");
      if (!faqBtns.length) return;
  
      faqBtns.forEach(btn => {
        btn.addEventListener("click", () => {
          const panel = btn.nextElementSibling;
          const open = !panel.classList.contains("hidden");
  
          faqBtns.forEach(b => {
            b.setAttribute("aria-expanded", "false");
            b.querySelector("svg").classList.remove("rotate-180");
          });
          document.querySelectorAll("#mobile-accordion-container .faq-panel").forEach(p => p.classList.add("hidden"));
  
          if (!open) {
            panel.classList.remove("hidden");
            btn.setAttribute("aria-expanded", "true");
            btn.querySelector("svg").classList.add("rotate-180");
          }
        });
      });
    }
  
    buildAccordion();
  
    // Watch for async Fitment table load
    const observer = new MutationObserver((mutations, obs) => {
      const fitment = document.querySelector("#cm-fitment-table");
      if (fitment && fitment.innerHTML.trim().length > 0) {
        buildAccordion();
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
  